export default __webpack_public_path__ + "static/media/topBanner.b5fc7a05.jpg";